define('core/can',[
	'can/util/library',
	'can/map/define',
	'can/map/sort',
	'can/model',
	'can/control/route',
	'can/view/stache',
	'can/component'
], function(can) {
	return can;
});
